import React from "react"
import { Button, ButtonType } from "components/atoms/Button"
import {
  SectionCard,
  SectionContent,
  SectionTitle,
  SectionText,
  SectionIllustration,
  Pill,
} from "./Card.styles"

interface SectionCardComponentProps {
  title: string
  paragraphs: string[]
  buttonText?: string
  buttonType?: ButtonType
  onButtonClick?: () => void
  imageSrc?: string
  imageAlt?: string
  pillText?: string
}

export const SectionCardComponent: React.FC<SectionCardComponentProps> = ({
  title,
  paragraphs,
  buttonText,
  buttonType = ButtonType.Solid,
  onButtonClick,
  imageSrc,
  imageAlt,
  pillText,
}) => {
  return (
    <SectionCard>
      <SectionContent>
        {pillText && <Pill>{pillText}</Pill>}
        <SectionTitle>{title}</SectionTitle>
        {paragraphs.map((paragraph, index) => (
          <SectionText key={index}>{paragraph}</SectionText>
        ))}
        {buttonText && <Button type={buttonType} text={buttonText} onClick={onButtonClick} />}
      </SectionContent>

      {imageSrc && (
        <SectionIllustration>
          <img src={imageSrc} alt={imageAlt || title} />
        </SectionIllustration>
      )}
    </SectionCard>
  )
}
